export default __webpack_public_path__ + "static/media/calendar.d2dd8b4b.svg";